import React from "react";
import * as Listing6 from "../../../../../../domain/models/Listing6";
import { INVESTOR_FIGURES_CAVEAT, investorFactRows } from "../../../../../../domain/listing/investorFigures";
import { ListingFactPanel } from "../ListingFactPanel/ListingFactPanel";

export type TListingInvestorBlockProps = {
    figures: Listing6.TInvestorFigures;
};

export const hasAnythingToShow = (figures: Listing6.TInvestorFigures): boolean =>
    investorFactRows(figures).length > 0;

export const ListingInvestorBlock = (props: TListingInvestorBlockProps): JSX.Element | null =>
    <ListingFactPanel
        heading="Investment potential"
        facts={investorFactRows(props.figures)}
        footnote={INVESTOR_FIGURES_CAVEAT}
    />;
